export default __webpack_public_path__ + "static/media/salle.4c53f512.png";